import {updateObject} from "../../../shared/utils/updateObject";
import * as actionTypes from "../eventi/actionTypes";

const initialState = {
    tableData: [],
    tableLoading: false,
    count: 0,
    eventiDetails: [],
    eventiDetailsLoading: false,
    downloadCsvLoading: false
}

const setEventsData = (state, action) => {
    return updateObject(state, {tableData: action.payload, count: action.count});
}

const setEventsTableLoading = (state, action) => {
    return updateObject(state, {tableLoading: action.value});
}

const setEventDetailsData = (state, action) => {
    return updateObject(state, {eventiDetails: action.payload});
}

const setEventDetailsLoading = (state, action) => {
    return updateObject(state, {eventiDetailsLoading: action.value});
}

const setDownloadCsvLoading = (state, action) => {
    return updateObject(state, {downloadCsvLoading: action.payload});
}

const eventiReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_EVENTS_DATA:
            return setEventsData(state, action);
        case actionTypes.SET_LOADING_EVENTS_DATA:
            return setEventsTableLoading(state, action)
        case actionTypes.GET_EVENT_DETAILS_DATA:
            return setEventDetailsData(state, action)
        case actionTypes.SET_EVENT_DETAILS_DATA_LOADING:
            return setEventDetailsLoading(state, action)
        case actionTypes.SET_EVENT_LOGS_DOWNLOAD_CSV_LOADING:
            return setDownloadCsvLoading(state, action)
        default:
            return state;
    }
};

export default eventiReducer;

